import CreatableSelect from 'react-select/creatable';
import Select from "react-select";
import { useSelectSkill } from '../../../shared/hooks/use-selectSkill';
import { useSelector } from 'react-redux';

const MultiSelect = ({ options, placeholder, name, title, value, onChange, onBlur, isDisabled, minMenuHeight, menuPlacement, maxMenuHeight, isSearchable, components, filterOption, type, isMulti, onFocus, onInputChange, menuIsOpen, arrow }: any) => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    let styles = useSelectSkill(arrow, theme);

    return (
        <div className="flex flex-col gap-[4px]">
            <h6 className="text-blackDark font-medium">{title}</h6>
            {type === "select" ?
                <Select
                    options={options}
                    name={name}
                    placeholder={placeholder}
                    styles={styles}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    isDisabled={isDisabled}
                    minMenuHeight={minMenuHeight}
                    menuPlacement={menuPlacement}
                    maxMenuHeight={maxMenuHeight}
                    isSearchable={isSearchable}
                    components={components}
                    filterOption={filterOption}
                    isMulti={isMulti}
                    onFocus={onFocus}
                    onInputChange={onInputChange}
                    classNamePrefix="react-select"
                />
                :
                <CreatableSelect
                    options={options}
                    name={name}
                    placeholder={placeholder}
                    styles={styles}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    isDisabled={isDisabled}
                    minMenuHeight={minMenuHeight}
                    menuPlacement={menuPlacement}
                    maxMenuHeight={maxMenuHeight}
                    isSearchable={isSearchable}
                    components={components}
                    filterOption={filterOption}
                    isMulti={isMulti}
                    onFocus={onFocus}
                    onInputChange={onInputChange}
                    menuIsOpen={menuIsOpen}
                    classNamePrefix="react-select"
                />
            }
        </div>
    );
};

export default MultiSelect;